module.exports = __webpack_public_path__ + "static/media/wordmark_white.d0ed94b5.png";